import React from 'react';
import { NonDismissableModal, Container, Button, TextLink } from 'ui';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Illustration } from 'assets/not-logged-in.svg';
import { LoginButtons } from 'Authentication/LoginButtons';

export const LoginPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center w-full h-full">
      <Container>
        <div
          className="-mx-5 md:-mx-0 col-span-full lg:col-span-4 lg:col-start-5 md:col-start-3 md:col-span-4 sm:col-span-4 sm:col-start-3"
          data-cy="login-prompt-window"
        >
          <NonDismissableModal
            header={t('landingPage:loginPageV2.header')}
            description={t('landingPage:loginPageV2.description')}
            illustration={
              <div className="flex items-center justify-center w-80 h-44">
                <Illustration className="flex-shrink-0 w-32 h-32" />
              </div>
            }
            additionalContent={
              <TextLink href={t('landingPage:loginPageV2.descriptionButtonLink')}>
                {t('landingPage:loginPageV2.descriptionButton')}
              </TextLink>
            }
            spaceBetween="4"
            ctaSection={
              <div className="flex flex-col -m-1 space-y-2 items-center">
                <LoginButtons
                  render={({ singpassButtonOnClick, corppassButtonOnClick }) => (
                    <div className="flex flex-col space-y-4">
                      <Button
                        label={t('landingPage:loginPageV2.ctaSection.businessButton')}
                        onClick={corppassButtonOnClick}
                        data-sentry-ignore-slow-click
                      />
                      <p className="text-center link-small p-1 text-gray-70">
                        {t('landingPage:loginPageV2.singpassMessage')}{' '}
                        <button
                          className="hover:text-primary-50 active:text-primary-70 text-primary-60 "
                          onClick={singpassButtonOnClick}
                          data-sentry-ignore-slow-click
                        >
                          {t('landingPage:loginPageV2.ctaSection.individualButton')}
                        </button>
                      </p>
                    </div>
                  )}
                  redirectPath="/"
                />
              </div>
            }
          />
        </div>
      </Container>
    </div>
  );
};
